import React, { Component } from 'react';
import { Link } from 'react-router';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import Cookies from 'universal-cookie';
import LoadingBoxes from '../components/loadingBoxes';
import LoadingText from '../components/loadingText';
import { fetch_account } from '../actions/fetch_account';
import { reloadPage } from '../utility/tool';
import { userLogout } from '../utility/logout';
import '../styles/account.css';

let cookies = new Cookies();

class Account extends Component {
	constructor(props){
		super(props)
	}

	componentDidMount(){
		window.scrollTo(0, 0)

		if(cookies.get('user_id')) {
			this.props.fetch_account(cookies.get('user_id'), cookies.get('token'))
		}
	}

	checkAccountType(type) {
	    switch (type) {
	        case '0':
	            return '免費'
	        case '1':
	            return '付費'
	        case '2':
	            return '後台'
	        default:
	            return ''
	    }
	}

  	render() {
  		const {
  			account,
  			account_isloading,
  			account_error
  		} = this.props;

  		if(!cookies.get('user_id')) {
  	  		return (
				<div className="errormsg">
					<p className="errormsgCenter">查無資料，請重新搜尋[1]</p>
					<Link to="/" className="refreshBtn">
						<span className="refreshIconText">點我去首頁</span>
					</Link>
				</div>
  	  		)
  		}

  		if(account_isloading){
  			return(
  			  <div>
  			    <LoadingBoxes />
  			    <LoadingText />
  			  </div>
  			)
  		}

	  	if(account_error !== false) {
			if(account_error.status === 401) {
				setTimeout(function(){ userLogout(); }, 3000);
				return <p className="errormsg">您的登入期間已過期，請重新登入</p>;
	  		} else {
	  	  		return (
					<div className="errormsg">
						<p className="errormsgCenter">資料未完成載入，請稍後再試</p>
						<div className="refreshBtn" onClick={() => {reloadPage()}}>
							<span className="refreshIcon"></span>
							<span className="refreshIconText">重新整理</span>
						</div>
					</div>
	  	  		)
	  		}
	  	}

  		if(account.data === undefined || account.data === null) {
  	  		return (
				<div className="errormsg">
					<p className="errormsgCenter">查無資料，請重新搜尋[2]</p>
					<Link to="/" className="refreshBtn">
						<span className="refreshIconText">點我去首頁</span>
					</Link>
				</div>
  	  		)
  		}

	    return(
			<div className="accountWrapper">
				<Link to="/" className="goBackBox">
					<span className="icon_return"></span>
					<p className="message">Back</p>
				</Link>
				<div className="basicInfo">
					<h3 className="sectionTitle">個人檔案</h3>
					<div className="row">
						<div className="rowItem left">帳號</div>
						<div className="rowItem right">{account.data.account}</div>
					</div>
					<div className="row">
						<div className="rowItem left">姓名</div>
						<div className="rowItem right">{account.data.name}</div>
					</div>
					<div className="row">
						<div className="rowItem left">公司</div>
						<div className="rowItem right">{account.data.company}</div>
					</div>
					<div className="row">
						<div className="rowItem left">聯絡電話</div>
						<div className="rowItem right">{account.data.tel}</div>
					</div>
					<div className="row">
						<div className="rowItem left">帳號類型</div>
						<div className="rowItem right">{this.checkAccountType(account.data.accountType)}</div>
					</div>
					<div className="row">
						<div className="rowItem left">使用方案</div>
						<div className="rowItem right">{account.data.plan}</div>
					</div>
					<div className="row">
						<div className="rowItem left">使用期限</div>
						<div className="rowItem right">{account.data.startDate} ~ {account.data.endDate}</div>
					</div>
					<div className="row">
						<div className="rowItem left">已登入次數</div>
						<div className="rowItem right">{account.data.loginCounts}</div>
					</div>
					<div className="row">
						<div className="rowItem left">最近登入時間</div>
						<div className="rowItem right">{account.data.lastLogin}</div>
					</div>
				</div>
	        </div>
	    )
   }

}

function mapStateToProps({ account, account_isloading, account_error }) {
  return { account, account_isloading, account_error };
}

function mapDispatchToProps(dispatch) {
  return bindActionCreators({ fetch_account }, dispatch);
}

export default connect(mapStateToProps,mapDispatchToProps )(Account);



// WEBPACK FOOTER //
// ./src/containers/account.js